export default __webpack_public_path__ + "static/media/p14.94f097f7.jpeg";